import { render, staticRenderFns } from "./ProjectVacancy.vue?vue&type=template&id=00bd16c1&scoped=true"
import script from "./ProjectVacancy.vue?vue&type=script&lang=js"
export * from "./ProjectVacancy.vue?vue&type=script&lang=js"
import style0 from "./ProjectVacancy.vue?vue&type=style&index=0&id=00bd16c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd16c1",
  null
  
)

export default component.exports